"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BDSBadge = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var BDSBadge_style_1 = require("./BDSBadge.style");
var BDSBadge = function (_a) {
    var children = _a.children, style = _a.style;
    return (jsx_runtime_1.jsx("div", tslib_1.__assign({ css: BDSBadge_style_1.BDSBadgeCss, style: style }, { children: children }), void 0));
};
exports.BDSBadge = BDSBadge;
exports.BDSBadge.defaultProps = {
    style: undefined,
};
